(function () {
    'use strict';

    angular.module("imApp").factory("productLinksChangeService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1828,
                    parameters: parms || {}
                });
            },
            listProductLinksChanges: function (parms) {
                return $ihttp.post({
                    method: 1829,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1830,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
